import PropTypes from 'prop-types'
import RoundedImage from '../../Generics/RoundImage'

const RetailerLink = ({
  retailerLogoSrc,
  retailerLogoHref,
  brandColorBg,
  onLogoClick,
  isRetailerLogoClickDisabled,
}) => {
  const commonProps = {
    dataTest: 'CampaignHeaderLogo',
    backgroundColor: brandColorBg,
    src: retailerLogoSrc,
  }

  if (isRetailerLogoClickDisabled) {
    return (
      <RoundedImage
        {...commonProps}
      />
    )
  }
  return (
    <a href={retailerLogoHref} data-test="CampaignHeaderLogoLink">
      <RoundedImage
        onClick={onLogoClick}
        {...commonProps}
      />
    </a>
  )
}

RetailerLink.propTypes = {
  retailerLogoSrc: PropTypes.string,
  retailerLogoHref: PropTypes.string,
  brandColorBg: PropTypes.string,
  onLogoClick: PropTypes.func,
  isRetailerLogoClickDisabled: PropTypes.bool,
}

RetailerLink.defaultProps = {
  retailerLogoSrc: undefined,
  retailerLogoHref: '',
  brandColorBg: '',
  onLogoClick: '',
  isRetailerLogoClickDisabled: false,
}

RetailerLink.displayName = 'RetailerLink'

export default RetailerLink
